'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

var _RootNode = require('../utils/RootNode');

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _PortalLayer = require('./internal/PortalLayer');

var _PortalLayer2 = _interopRequireDefault(_PortalLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UILayer = function (_React$Component) {
  _inherits(UILayer, _React$Component);

  function UILayer(props) {
    _classCallCheck(this, UILayer);

    var _this = _possibleConstructorReturn(this, (UILayer.__proto__ || Object.getPrototypeOf(UILayer)).call(this, props));

    _this.handleCloseComplete = function () {
      var _this$props = _this.props,
          onCloseComplete = _this$props.onCloseComplete,
          transitionProps = _this$props.transitionProps;

      (0, _Functions.callIfPossible)(transitionProps && transitionProps.onCloseComplete);
      (0, _Functions.callIfPossible)(onCloseComplete);
      _this._rootNode.removeChild(_this._element);
    };

    _this.renderTree = function (content, forceTransitionOnMount) {
      var _this$props2 = _this.props,
          Transition = _this$props2.Transition,
          transitionProps = _this$props2.transitionProps;


      if (!Transition) return content;
      return _react2.default.createElement(
        Transition,
        _extends({}, transitionProps, {
          onCloseComplete: _this.handleCloseComplete,
          transitionOnMount: forceTransitionOnMount || transitionProps && transitionProps.transitionOnMount
        }),
        content
      );
    };

    _this._rootNode = props.rootNode || (0, _RootNode.getDefaultNode)();
    _this._element = document.createElement('div');
    _this._element.className = 'private-layer';
    _this._element.setAttribute('data-layer-for', props['data-layer-for']);
    _this._rootNode.appendChild(_this._element);
    return _this;
  }

  _createClass(UILayer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var Transition = this.props.Transition;

      if (!Transition) this.handleCloseComplete();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        _PortalLayer2.default,
        { element: this._element, renderTree: this.renderTree },
        children
      );
    }
  }]);

  return UILayer;
}(_react2.default.Component);

UILayer.propTypes = {
  children: _propTypes2.default.node.isRequired,
  'data-layer-for': _propTypes2.default.string,
  onCloseComplete: _propTypes2.default.func,
  rootNode: _domElement2.default,
  Transition: _propTypes2.default.elementType,
  transitionProps: _propTypes2.default.object
};

UILayer.displayName = 'UILayer';

exports.default = UILayer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/layer/UILayer.js
// module id = 201
// module chunks = 177